import { render, staticRenderFns } from "./LeitoIcon.vue?vue&type=template&id=22c9c55a"
import script from "./LeitoIcon.vue?vue&type=script&lang=js"
export * from "./LeitoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports